import tw, { css, styled } from 'twin.macro'
import { RiLoader5Fill } from 'react-icons/ri'
import { formatNumber } from '../helpers'

const Card = ({
  loading,
  title,
  value,
  rawChanged24Hrs,
  displayChanged24Hrs,
  isCurrency = true,
}) => {
  return loading ? (
    <div className="flex justify-center">
      <RiLoader5Fill size="3em" className="loader" />
    </div>
  ) : (
    <StickyCardBox width="w-full" height="h-[6.25rem] lg:h-[6.25rem]">
      <div className="md:mt-[1.0938rem] md:mb-[1.2188rem] ml-[2rem] text-center">
        <div className="text-[1rem] font-normal not-italic leading-[1.2188rem] text-white-0">
          {title}
        </div>
        <div className="text-2xl text-white-1">
          {!isCurrency
            ? formatNumber(value, { currency: false })
            : formatNumber(value, { currency: true })}
        </div>
        <div
          className={`text-base ${
            rawChanged24Hrs >= 0 ? 'text-green-profit' : 'text-gray-5'
          }`}
          title="Change since previous day"
        >
          {rawChanged24Hrs >= 0 ? '+' : ''}
          {displayChanged24Hrs}
        </div>
      </div>
    </StickyCardBox>
  )
}

const Box = styled.div(() => [
  tw`flex rounded-t-xl rounded-r-xl rounded-b-xl border-[1px] border-gray-5`,
  css`
    background: linear-gradient(136.96deg, #242424 0%, #2d2d2d 103.66%);
  `,
])

const StickyCardBox = ({ width, height, children }) => {
  return (
    <Box className={`${width} ${height}`}>
      <div
        className="flex h-auto min-w-[8px] rounded-l-xl border-gray-5
        bg-yellow-2 xl:w-[12px]"
      />
      <div className="flex flex-col align-center w-full justify-center -ml-4">
        {children}
      </div>
    </Box>
  )
}

export default Card
